/** @prettier */
export const getCategoryUrlFromTags = (tags, eventTags) => {
  const groupedTags = tags
    .filter(
      (tag) => tag.type === 'COUNTRY' || (tag.type === 'OTHER' && tag.urlName === 'uk-ireland')
    )
    .groupBy(({ urlName }) => urlName);

  const filteredTag = eventTags.filter((tag) => {
    if (groupedTags.get('ireland') && groupedTags.get('uk')) {
      return (tag.type === 'OTHER' && tag.urlName === 'uk-ireland') || tag.type === 'COUNTRY';
    }
    return tag.type === 'COUNTRY';
  });

  return filteredTag[0] ? filteredTag[0].urlName : undefined;
};

export default getCategoryUrlFromTags;
